import { Link } from 'react-router-dom';
import type { Post } from '@/core/models/post';

export function Coauthors({ post }: { post: Post }) {
  if (post.deleted || post.removed || !post.coauthors?.length) return null;
  return (
    <p>
      Co-authored with{' '}
      {post.coauthors.map((author, index) => (
        <span key={author.id}>
          {index > 0 && ', '}
          <Link
            to={`/profile/${encodeURIComponent(author.handle)}`}
            onClick={(e) => e.stopPropagation()}
          >
            {author.name || `@${author.handle}`}
          </Link>
        </span>
      ))}
    </p>
  );
}
